<script>
  import Header from '../header.svelte'
  import Tester from '../tester.svelte'
  export let content
</script>

<div class="cols4-wrapper">
  <div class="tester">
    <Tester content={content.tester} />
  </div>
</div>

<style>
  .tester {
    grid-column: 1 / span 3;
  }
</style>
